import * as yup from 'yup'

const schema = yup.object({
  fullName: yup.string().required('Full Name is required'),
  email: yup.string().required(),
  interested: yup.string().required('Interested Department is required'),
  message: yup.string().required('Message is required'),
})

export default schema
